// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4a4adb30","485":"40f5c5f8"}[chunkId] + ".chunk.js";
};